import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Link, useLocation } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import { useCountry } from "../contexts/countrycodecontext.js";
import WYSIWYGEditor from "../helpers/WYSIWYGEditor.js";
import ConsultantLayout from "../commonlayouts/consultantlayout.js";
import { CustomEmail } from "../apiconstants/constants.js";
const SendFollowupEmail = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");
  const [selectedCCEmail, setSelectedCCEmail] = useState("");
  const token = localStorage.getItem("jwtToken");

  const location = useLocation();
  const {
    emailToSend,
    nameToSend,
    candidateName,
    candidateEmail,
    staffingContactName,
    staffingContactEmail,
    staffingContactCompanyName,
    jobRoleName,
    emailType, // "candidate" or "followup"
  } = location.state || {};
  const {selectedCountry} = useCountry();  
  const loginName = localStorage.getItem("firstName");
  const guid = localStorage.getItem("guid");
  const email = localStorage.getItem("email");
  const candidateMobileNumber = localStorage.getItem("mobileNumber");

  const { register, handleSubmit, formState, control, reset, getValues } = useForm();
  const { errors, isSubmitting } = formState;
 useEffect(() => {
  if (selectedCountry == 2) {
    setSelectedCCEmail("bench.us@knackhook.com");
  } else {
    setSelectedCCEmail("staffing.in@knackhook.com");
  }
}, [selectedCountry]);
useEffect(() => {
  let bodyTemplate = "";

  if (emailType === "candidate") {
    bodyTemplate = `
      Hi ${candidateName},<br/><br/>
      I hope you’re doing well.
 
I wanted to let you know that we’ve submitted your profile for the <b>${jobRoleName}</b> position to the following staffing contact:
     <br/><br/>
      <b>Name:</b> ${staffingContactName}<br/>
      <b>Email:</b> ${staffingContactEmail}<br/>
     ${
    staffingContactCompanyName
      ? `<b>Company:</b> ${staffingContactCompanyName}<br/>`
      : ""
  }
     Please remember these contact details, as you may receive a call or email from them. Once you do, kindly respond promptly- timely communication will help us move forward quickly and increase your chances of securing the interview.
 <br/>
We’ll keep you posted as soon as we receive any feedback or updates.<br/>
    `;
  } else if (emailType === "followup") {
    bodyTemplate = `
      Hi ${staffingContactName},<br/><br/>
      Hope you’re doing well.
 
This is <b>${loginName}</b> from KnackHook LLC, and I work as a Benchsales Recruiter. I wanted to follow up regarding our candidate, <b>${candidateName}</b>, who was submitted for the <b>${jobRoleName}</b> position.
 
Could you please share the latest feedback or any updates on the candidate's status? It would help us coordinate next steps accordingly.
 
Looking forward to your response.
     
    `;
  }

  const defaultTemplate = bodyTemplate;

  reset({
    fromEmail: email || "",
    toEmail: emailToSend || "",
    candidateName: candidateName || "",
    subject: `KnackHook - Submission ${emailType === "candidate" ? "Intimation" : "Follow-up"} - ${candidateName || ""}`,
    content: defaultTemplate,
  });
}, [
  emailType,
  emailToSend,
  candidateName,
  staffingContactName,
  staffingContactEmail,
  staffingContactCompanyName,
  jobRoleName,
  email,
  candidateMobileNumber,
  reset
]);

  // 👁️ Preview Email
  const handlePreview = () => {
    if (showPreview) {
      setShowPreview(false);
      setPreviewHtml("");
      return;
    }

    const values = getValues();
    const previewHtml = `
      <p>${values.content}</p>
      <p>Best regards,<br />
      <strong>KnackHook Staffing Team,</strong><br />
      ✉️ <a href="mailto:${values.fromEmail}">${values.fromEmail},</a><br />
      📞 ${candidateMobileNumber}.</p>
    `;

    setPreviewHtml(previewHtml);
    setShowPreview(true);
  };

  // 📤 Submit Follow-Up Email
  const onSubmit = async (data, e) => {
    e.preventDefault();
    setIsDisabled(true);

    try {
      const followUpPayload = {
        fromEmail: data.fromEmail,
        toEmail: data.toEmail,
        subject: data.subject,
        content: data.content,
        cc: data.selectedCCEmail||selectedCCEmail,
        phoneNumber: candidateMobileNumber,
        guid,
      };

      const result = await Axios.post(CustomEmail.APIURL, followUpPayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (result.data === "Screening test reminder email sent.") {
        Swal.fire({
          icon: "success",
          title: "Follow-Up Email Sent",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to Send Follow-Up Email",
        });
      }
    } catch (error) {
      console.error("Error sending follow-up email", error);
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Failed to send email. Please try again later.",
      });
    } finally {
      setIsDisabled(false);
      reset({
        fromEmail: email || "",
        toEmail: staffingContactEmail || "",
        candidateName: candidateName || "",
        subject: "",
        content: "",
      });
      setShowPreview(false);
    }
  };

  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
              <div style={{ display: "flex", alignItems: "center" }}>
                <Link to="/Employer/ViewBenchSalesReports">
                  <i  className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: 10 }}
                    aria-hidden="true" ></i>
                </Link>
<h2 style={{ color: "#00a7ac", margin: 0 }}>{emailType === "candidate" ? "Send Intimation Mail to Candidate"
    : "Send Follow-Up Mail"}
</h2>
              </div>
              <hr/>
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mt-4">
                {/* From Email */}
                <div className="col-sm-12 col-md-6">
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Sender's Email</Tooltip>}>
                    <input
                      type="email"
                      className="form-control basic-form"
                      placeholder="From Email"
                      {...register("fromEmail", { required: "From Email is required" })}
                    />
                  </OverlayTrigger>
                  {errors.fromEmail && (
                    <div className="invalid-feedback d-block">
                      {errors.fromEmail.message}
                    </div>
                  )}
                </div>

                {/* To Email */}
                <div className="col-sm-12 col-md-6">
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Email</Tooltip>}>
                    <input
                      type="email"
                      className="form-control basic-form"
                      placeholder="To Email"
                      {...register("toEmail", { required: "To Email is required" })}
                    />
                  </OverlayTrigger>
                  {errors.toEmail && (
                    <div className="invalid-feedback d-block">
                      {errors.toEmail.message}
                    </div>
                  )}
                </div>
              </div>

              {/* Candidate Name + Subject */}
              <div className="row mt-4">
                <div className="col-sm-12 col-md-6">
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Candidate Name</Tooltip>}>
                    <input
                      className="form-control basic-form"
                      type="text"
                      {...register("candidateName")}
                      placeholder="Enter candidate name"
                    />
                  </OverlayTrigger>
                </div>

                <div className="col-sm-12 col-md-6">
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Email Subject</Tooltip>}>
                    <input
                      type="text"
                      className="form-control basic-form"
                      placeholder="Subject"
                      {...register("subject", { required: "Subject is required" })}
                    />
                  </OverlayTrigger>
                  {errors.subject && (
                    <div className="invalid-feedback d-block">
                      {errors.subject.message}
                    </div>
                  )}
                </div>
              </div>

 <div className="row mt-4">
                {/* CC Email */}
                <div className="col-sm-12 col-md-6">
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>CC Email</Tooltip>}>
                    <input
      type="email"
      className="form-control basic-form"
      defaultValue={selectedCCEmail} // ✅ sets initial value
      {...register("selectedCCEmail")} // ✅ keeps it editable and managed by RHF
    />
                  </OverlayTrigger>
                
                </div>

               
              </div>
              {/* Content */}
              <div className="col-sm-12 mt-4">
                <label style={{ color: "#00a7ac", marginTop: 10 }}>Content</label>
                <Controller
                  control={control}
                  name="content"
                  rules={{
                    required: { value: true, message: "Content Required" },
                  }}
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <div>
                      <WYSIWYGEditor
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value || ""}
                        ref={ref}
                      />
                      {errors.content && (
                        <p style={{ marginTop: "0.25em", fontSize: "80%", color: "#dc3545" }}>
                          {errors.content.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>

              {/* Buttons */}
              <div className="row mt-4 p-0">
                <div className="col-12 d-flex justify-content-end gap-2">
                  <button type="button" className="btn btn-primary" onClick={handlePreview}>
                    {showPreview ? "✖ Close Preview" : "Show Preview"}
                  </button>

                  <button disabled={isSubmitting || isDisabled} className="btn btn-primary">
                    {isSubmitting && (
                      <span className="spinner-border spinner-border-sm me-2"></span>
                    )}
                    Send
                  </button>

                  <button
                    type="button"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    disabled={isSubmitting || isDisabled}
                    className="btn btn-primary"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>

            {/* Preview */}
            {showPreview && previewHtml && (
              <div
                className="mt-4 p-4 border rounded bg-light"
                style={{
                  backgroundColor: "transparent",
                  fontSize: "12px",
                  fontFamily: "Arial, sans-serif",
                  lineHeight: "1.5",
                }}
              >
                <h5>Email Preview</h5>
                <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
              </div>
            )}
          </div>
        </div>
      </section>
    </ConsultantLayout>
  );
};

export default SendFollowupEmail;
